<template>
  <div>
    <div class="container">
      <div class="user-info">
        <div>
          <div class="avatar">
            <div class="img"><img :src="avatar" alt="头像" /></div>
            <div class="name">{{ userInfo.name }}</div>
          </div>
        </div>
        <div class="info">
          <el-col :span="12">
            <el-row
              ><span class="label">性别</span>{{ gender(userInfo.gender) }}
            </el-row>
            <el-row><span class="label">年龄</span>{{ userInfo.age }}</el-row>
            <el-row
              ><span class="label">手机号</span>{{ userInfo.mobile }}</el-row
            >
            <el-row
              ><span class="label">账户</span>{{ userInfo.account }}</el-row
            >
          </el-col>
          <el-col :span="12">
            <el-row
              ><span class="label">开通时间</span
              >{{ parseTime(userInfo.created, '{y}-{m}-{d}') }}</el-row
            >
            <el-row v-if="this.role !== AccountType.ADJUSTMENT"
              ><span class="label">到期时间</span
              >{{ userInfo.expireDate }}</el-row
            >
            <el-row v-if="this.role !== AccountType.ADJUSTMENT"
              ><span class="label">剩余天数</span
              >{{ userInfo.openDay - userInfo.usedDay }}天</el-row
            >
            <el-row
              ><span class="label">已训练天数</span
              >{{ userInfo.usedDay }}天</el-row
            >
          </el-col>
        </div>
        <!-- <div
          class="handle"
          @click="handleShowRenewal"
          v-if="userInfo.onlineRenewal && this.role !== AccountType.ADJUSTMENT"
        >
          <el-button>立即续费</el-button>
        </div> -->
      </div>
      <div class="train-record">
        <el-table :data="recordData" v-loading="loading">
          <el-table-column
            label="训练日期"
            prop="date"
            align="center"
          ></el-table-column>
          <el-table-column
            label="训练项目"
            prop="content"
            align="center"
          ></el-table-column>
          <el-table-column label="训练时长" prop="duration" align="center">
            <template slot-scope="scope">
              {{ minAndSecond(scope.row.duration) }}
            </template>
          </el-table-column></el-table
        >
      </div>
    </div>
    <el-dialog
      custom-class="renewal-dialog"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="1100px"
      center
    >
      <div class="title">请选择续费时长</div>
      <div class="content">
        <div
          class="price-item"
          :class="{
            checked: renewalForm.priceId === item.id,
          }"
          @click="handlePrice(item)"
          v-for="(item, index) in priceData"
          :key="index"
        >
          <div class="gift" v-if="item.dayGift">赠送{{ item.dayGift }}天</div>
          <div class="day">{{ item.day }}天卡</div>
          <div class="remark">{{ item.remark }}</div>
          <div class="price">￥{{ item.retailPrice }}</div>
          <div class="price-day">
            ￥{{ (item.retailPrice / (item.day + item.dayGift)).toFixed(2) }}/天
          </div>
          <div class="check el-icon-check"></div>
        </div>
      </div>
      <div class="title">请选择支付方式</div>
      <div class="content">
        <div
          class="price-item"
          :class="{
            checked: renewalForm.payWay === item.name,
          }"
          @click="handlePayWay(item.name)"
          v-for="(item, index) in payWay"
          :key="index"
        >
          <img class="pay-way" :src="item.logo" alt="支付方式" />
          <div class="hr"></div>
          <div class="check el-icon-check"></div>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" class="renewal-btn" @click="handleRenewal"
          >立即续费</el-button
        >
      </div>
    </el-dialog>
    <!-- 微信支付 -->
    <el-dialog
      :visible.sync="wechatPayVisible"
      width="500px"
      center
      custom-class="wechat-dialog"
      @close="handleCloseWechatPay"
    >
      <span slot="title" class="diaTitle">微信支付</span>
      <div class="total">
        合计金额： <span class="num">￥{{ amountPay }}</span>
      </div>
      <div class="wxImg">
        <div class="outer">
          <img
            :src="wechatPayUrl"
            style="margin-top: 25px"
            height="200px"
            alt
          />
          <div class="text">请打开微信扫一扫支付</div>
        </div>
        <div class="outer">
          <img src="@/assets/images/wxPay.png" width="200px" alt />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="paySuccessVisible"
      width="500px"
      center
      custom-class="success-dialog"
      @close="handleClosePaySuccess"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="icon"><i class="el-icon-circle-check-outline"></i></div>
      <div class="title">恭喜您续费成功</div>
      <div class="info">
        <div>
          <span class="label">续费时长：</span>{{ paySuccessForm.buyDay }}天卡
        </div>
        <div>
          <span class="label">续费方式：</span
          >{{ paySuccessForm.type === 2 ? '支付宝' : '微信支付' }}
        </div>
        <div>
          <span class="label">实付金额：</span
          ><span class="amount">￥{{ paySuccessForm.amount }}</span>
        </div>
      </div>
      <el-button type="primary" round @click="handleClosePaySuccess"
        >确认</el-button
      >
    </el-dialog>
    <el-dialog
      :visible.sync="confirmPayVisible"
      width="500px"
      center
      custom-class="success-dialog"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-button @click="_getPayStatus()">支付完成</el-button>
      <el-button @click="confirmPayVisible = false">取消支付</el-button>
    </el-dialog>
    <el-dialog
      :visible.sync="expireVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <div class="expire-dialog">
        <div class="title">您的账户已到期，请及时联系训练师续费</div>
        <img class="qr-code" :src="renewalQrCode" alt="" />
        <div class="info">
          <div v-if="address">地址：{{ address }}</div>
          <div>客服电话：{{ phone }}</div>
          <div v-if="phone !== defaultPhone">
            瞬检视界客服电话：{{ defaultPhone }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import QRCode from 'qrcode'
import boy from '@/assets/images/boy.png'
import girl from '@/assets/images/girl.png'
import alipayLogo from '@/assets/images/alipay.png'
import wechatpayLogo from '@/assets/images/wechatpay.png'
import { parseTime, minAndSecond, gender } from '@utils'
import {
  getTrainRecord,
  getRenewalList,
  wechatPay,
  getPayStatus,
} from '@api/train'
import { namespace } from 'vuex-class'
import { AccountType } from '@/constant/user'
const moduleUser = namespace('user')
const ALIPAY = 'ALIPAY'
const WECHATPAY = 'WECHATPAY'
@Component
export default class MyAccount extends Vue {
  @moduleUser.State userInfo
  @moduleUser.Getter isExpire
  @moduleUser.Getter renewalQrCode
  @moduleUser.Getter phone
  @moduleUser.Getter address
  @moduleUser.Getter role

  introForm = {}
  introDialog = false
  parseTime = parseTime
  minAndSecond = minAndSecond
  gender = gender
  recordData = []
  loading = false
  dialogVisible = false
  priceData = []
  ALIPAY = ALIPAY
  WECHATPAY = WECHATPAY
  payWay = [
    {
      name: ALIPAY,
      logo: alipayLogo,
    },
    {
      name: WECHATPAY,
      logo: wechatpayLogo,
    },
  ]
  renewalForm = {
    priceId: '',
    payWay: '',
  }
  wechatPayUrl = ''
  wechatPayVisible = false
  amountPay = ''
  tradeNo = ''
  payStatusTimer = null
  paySuccessForm = {
    amount: '',
    buyDay: '',
    type: '',
  }
  paySuccessVisible = false
  confirmPayVisible = false
  expireVisible = false
  defaultPhone = '010-86460487'
  AccountType = AccountType
  get avatar() {
    return this.userInfo.gender === 0 ? boy : girl
  }

  created() {
    if (this.$route.query.out_trade_no) {
      this._getPayStatus(this.$route.query.out_trade_no)
    } else {
      this._getTrainRecord()
    }
    if (this.isExpire) {
      if (this.userInfo.onlineRenewal) {
        this.handleShowRenewal()
      } else {
        this.expireVisible = true
      }
    }
  }

  async handleShowRenewal() {
    this.dialogVisible = true
    this.renewalForm.priceId = ''
    this.renewalForm.payWay = ''
    await this._getRenewalList()
  }

  handlePrice({ id, retailPrice }) {
    this.renewalForm.priceId = id
    this.amountPay = retailPrice
  }

  handlePayWay(name) {
    this.renewalForm.payWay = name
  }

  async handleRenewal() {
    if (!this.renewalForm.priceId)
      return this.$message.warning('请选择续费时长')
    if (!this.renewalForm.payWay) return this.$message.warning('请选择支付方式')
    if (this.renewalForm.payWay === ALIPAY) {
      this.confirmPayVisible = true
      const routerData = this.$router.resolve({
        path: '/alipay',
        query: {
          priceId: this.renewalForm.priceId,
        },
      })
      window.open(routerData.href, '_blank')
    } else if (this.renewalForm.payWay === WECHATPAY) {
      const { data } = await wechatPay(this.renewalForm.priceId)
      const url = JSON.parse(data.result).code_url
      this.tradeNo = data.tradeNo
      this.wechatPayUrl = await QRCode.toDataURL(url)
      this.wechatPayVisible = true
      this.payStatusTimer = window.setInterval(async () => {
        this._getPayStatus(this.tradeNo)
      }, 2000)
    }
  }

  handleCloseWechatPay() {
    window.clearInterval(this.payStatusTimer)
  }

  handleClosePaySuccess() {
    this.$router.push({ query: { curTrainType: 'myAccount' } })
    location.reload()
  }

  async _getPayStatus(id) {
    const { data } = await getPayStatus(id)
    if (data.paySuccess) {
      this.paySuccessForm = data
      this.wechatPayVisible = false
      this.paySuccessVisible = true
    } else if (data.type === 2) {
      this.$message.warning('没有查询到支付结果')
      this.confirmPayVisible = false
    }
  }

  async _getTrainRecord() {
    try {
      this.loading = true
      const { data } = await getTrainRecord()
      this.recordData = data
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  }

  async _getRenewalList() {
    try {
      const { data } = await getRenewalList()
      this.priceData = data
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0 100px;
  .user-info {
    height: 257px;
    background: #fffbd5;
    border-radius: 40px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    align-items: center;
    justify-items: center;
    .avatar {
      width: 177px;
      height: 177px;
      position: relative;
      .img img {
        width: 100%;
        height: 100%;
      }
      .name {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 39px;
        line-height: 39px;
        text-align: center;
        background: #e78644;
        border-radius: 20px;
        transform: translateY(50%);
        font-size: 25px;
        color: #fff;
        font-weight: bold;
      }
    }
    .info {
      .el-row {
        width: 350px;
        font-size: 20px;
        line-height: 2;
        color: #666666;
        .label {
          display: inline-block;
          width: 100px;
          text-align-last: justify;
          margin-right: 20px;
          &::after {
            content: '：';
            position: absolute;
          }
        }
      }
    }
    .handle {
      .el-button {
        width: 180px;
        height: 50px;
        background: #f8ac34;
        border-radius: 25px;
        font-size: 20px;
        color: #fff;
      }
    }
  }
  /deep/ .train-record {
    margin: 30px auto;
    thead tr {
      border-radius: 40px 40px 0px 0px;
      background-color: #99dcff;
      background-clip: border-box;
      height: 84px;
      th {
        background-color: transparent;
        &:first-child {
          border-radius: 40px 0 0 0;
        }
        &:nth-last-child(2) {
          border-radius: 0 40px 0 0;
        }
        .cell {
          font-size: 26px;
          line-height: 1.5;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }
}
/deep/ .renewal-dialog {
  border-radius: 10px;
  margin: 2vh auto !important;
  .el-dialog__header {
    height: 0;
    padding: 0;
    margin: 0;
  }
  .el-dialog__body {
    padding: 0px 70px;
    overflow: hidden;
    .title {
      margin: 50px 0 30px 0;
      font-size: 24px;
      color: #333;
      &::before {
        content: ' ';
        display: inline-block;
        width: 5px;
        height: 24px;
        background: #f8ac34;
        border-radius: 3px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    .content {
      display: grid;
      gap: 40px;
      grid-template-columns: repeat(auto-fill, 280px);
      justify-content: space-between;
      .price-item {
        overflow: hidden;
        width: 280px;
        border-radius: 12px;
        text-align: center;
        border: 2px solid #c6c6c6;
        &:hover {
          cursor: pointer;
        }
        &.checked {
          border: 2px solid #fecb00;
          .check {
            background: #fecb00;
          }
          .gift {
            background: #fecb00;
            color: #ca7c00;
          }
        }
        .gift {
          position: absolute;
          width: 127px;
          height: 35px;
          border-radius: 10px 0 10px 0;
          font-size: 18px;
          line-height: 35px;
          opacity: 0.8;
          background: #c6c6c6;
        }
        .day {
          margin-top: 60px;
          height: 21px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
        .remark {
          margin-top: 10px;
          height: 15px;
          font-size: 14px;
          font-weight: bold;
          color: #666666;
          opacity: 0.8;
        }
        .price {
          margin-top: 15px;
          height: 24px;
          font-size: 30px;
          font-weight: bold;
          color: #f8ac34;
        }
        .price-day {
          margin-top: 15px;
          height: 15px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          opacity: 0.8;
        }
        .pay-way {
          margin-top: 35px;
        }
        .hr {
          height: 2px;
          margin: 30px 30px 0;
          border: 2px solid #c6c6c6;
          opacity: 0.3;
        }
        .check {
          margin: 30px 0;
          width: 200px;
          height: 40px;
          border-radius: 20px;
          color: #fff;
          font-size: 30px;
          line-height: 40px;
          background: #c6c6c6;
        }
      }
    }
    .footer {
      text-align: center;
      .renewal-btn {
        margin: 60px auto;
        width: 218px;
        height: 48px;
        border-radius: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
}
.wxImg {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  .outer {
    width: 200px;
    display: flex;
    flex-flow: column;
    .text {
      width: 100%;
      height: 30px;
      background-color: #62b900;
      color: white;
      line-height: 30px;
      text-align: center;
      font-size: 18px;
    }
  }
}
/deep/ .wechat-dialog {
  border-radius: 10px;
  .total {
    text-align: center;
    font-size: 18px;
    color: #666666;
    line-height: 30px;
    .num {
      color: #595ed3;
      margin-top: 5px;
      font-size: 30px;
    }
  }
}

/deep/ .success-dialog {
  border-radius: 10px;
  .el-dialog__body {
    text-align: center;
  }
  .icon {
    font-size: 120px;
    line-height: 1;
    margin-top: 10px;
    color: #585ad6;
  }
  .title {
    margin-top: 40px;
    height: 23px;
    font-size: 24px;
    color: #080808;
  }
  .info {
    margin: 40px auto;
    width: 230px;
    font-size: 20px;
    color: #666666;
    text-align: left;
    line-height: 35px;
    .label {
      margin-right: 30px;
    }
    .amount {
      color: #f8ac34;
    }
  }
  .el-button {
    width: 220px;
    font-size: 18px;
    font-weight: bold;
  }
}
.expire-dialog {
  text-align: center;
  .title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .qr-code {
    width: 220px;
    border: 1px dashed #606266;
    padding: 10px;
  }
  .info {
    font-size: 16px;
    font-weight: 700;
    margin: 30px 40px 0;
    div {
      margin-top: 10px;
    }
  }
}
</style>
